<template>
  <div class="guide" ref="guide">
    <div class="guide-container">
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f7f8c73ffc6ee077e618440b44e8e0ec.png"
        alt=""
      />
      <div class="point-list">
        <div
          class="point-item"
          v-for="(item, index) in pointList"
          @click="bindClick(item)"
          :style="{
            left: getPosition(item.left),
            top: getPosition(item.top),
            width: getPosition(item.width),
            height: getPosition(item.height)
          }"
          :key="index"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pointList: [
        {
          title: '内核稳定',
          left: 159,
          top: 170,
          width: 60,
          height: 60,
          image: ''
        },
        {
          title: '头发',
          left: 127,
          top: 255,
          width: 60,
          height: 60,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1a95bad687525d4b32f62e3bdd922690.png'
        },
        {
          title: '皮肤',
          left: 191,
          top: 255,
          width: 60,
          height: 60,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/168be773325fdeced6ad747a22a12c95.png'
        },
        {
          title: '睡眠',
          left: 91,
          top: 338,
          width: 60,
          height: 60,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b37772e8b158f7b381432eb3bc972ddc.png'
        },
        {
          title: '情绪',
          left: 157,
          top: 338,
          width: 60,
          height: 60,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/09abfd5306c3efe93011a1ac578580ae.png'
        },
        {
          title: '状态',
          left: 226,
          top: 338,
          width: 60,
          height: 60,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f6b4ffb267e3cba314b534457faf0708.png'
        },
        {
          title: '苹果型',
          left: 77,
          top: 420,
          width: 60,
          height: 60,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/44f2247944488058eed923518105ab54.png'
        },
        {
          title: '梨型',
          left: 157,
          top: 420,
          width: 60,
          height: 60,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e59e9f0aa164db0ae3b69dff99d2fd73.png'
        },
        {
          title: '全身型',
          left: 239,
          top: 420,
          width: 60,
          height: 60,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/488697acc0cd27f868380fe0728c9a7f.png'
        },
        {
          title: '放纵减肥法',
          left: 60,
          top: 500,
          width: 260,
          height: 60,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b1d6aab911d430fcfb140704db36828d.png'
        }
      ]
    }
  },
  methods: {
    getPosition(position) {
      let designWidth = 375
      let screenWidth = window.screen.width || 375
      return (position * screenWidth) / designWidth + 'px'
    },
    bindClick(item) {
      if (item.image) {
        this.$router.push(
          '/common-preview-image?imageUrl=' + encodeURIComponent(item.image)
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.guide {
  min-height: 100vh;
  background-color: rgba(241, 226, 198);

  .guide-container {
    width: 100%;
    height: 722px;
    position: relative;

    .image {
      width: 100%;
      height: 100%;
    }

    .point-list {
      .point-item {
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
  ::v-deep .guide-preview {
    .van-image-preview__image--vertical {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
    }
    .van-image__img {
      height: auto;
    }
  }
}
</style>
